import type { RouteHandle } from '@common/components/layout/routeHandle';
import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router-dom';

export type { RouteHandle };

export function DocumentTitle() {
  const { t } = useTranslation(['common', 'auth']);
  const title = useMatches()
    .map((match) => (match.handle as RouteHandle | undefined)?.title)
    .findLast(Boolean)?.(t);

  return <title>{`NTConsult - ${title ?? t('common:appName')}`}</title>;
}
